/**
 * Worker API base path. REACT_APP_BACKEND_URL may be origin only or already include `/api`;
 * appending `/api` twice breaks routing (e.g. `/api/api/acharya/query` → Worker 404).
 */
export function getApiBaseUrl() {
  let base = String(process.env.REACT_APP_BACKEND_URL || "").trim();
  base = base.replace(/\/+$/, "");
  if (!base) return "/api";
  if (/\/api$/i.test(base)) return base;
  return `${base}/api`;
}
